"use strict";

exports.__esModule = true;
exports.asyncLoader = void 0;

// eslint-disable-next-line require-await

/**
 * Loads scripts asynchronously
 *
 * @export
 * @param {*} url
 * @param {*} id
 * @param {*} [callback=undefined]
 * @returns
 */
const asyncLoader = function (url, id, callback = undefined) {
  try {
    return Promise.resolve(new Promise((resolve, reject) => {
      try {
        const b = document;
        const c = 'script';
        const d = b.createElement(c);
        d.src = url;
        d.type = `text/java${c}`;
        d.id = id;
        d.async = true;
        const a = b.getElementsByTagName('head')[0];
        d.addEventListener('load', () => {
          // eslint-disable-next-line no-console
          callback();
          return resolve();
        }, false);
        a.appendChild(d);
      } catch {
        reject();
      }
    }));
  } catch (e) {
    return Promise.reject(e);
  }
};

exports.asyncLoader = asyncLoader;